export const isNameValid = (name) => {
    if (name.trim()) {
        return true;
    }
    return false;
};
